const standByCardsGroupsReducer = (data = [], action) => {
    switch(action.type){
        case 'STAND_BY_CARDSGROUPS':
            data = action.data
            return  [...data];
        default:
            return data;
    }
}

export default standByCardsGroupsReducer;